export default __webpack_public_path__ + "static/media/imgQuimicaSanguinea.3c94287b.png";